function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { createElement } from 'react';
import { classnames } from '@bydesign-ui/utils';
import { usePrefixCls } from '@byte-design/config';

function wrapperDecorations(_ref, content) {
  var mark = _ref.mark,
      code = _ref.code,
      underline = _ref.underline,
      del = _ref.del,
      italic = _ref.italic,
      strong = _ref.strong;
  var currentContent = content;

  function wrap(needed, tag) {
    if (!needed) {
      return;
    }

    currentContent = createElement(tag, {
      children: currentContent
    });
  }

  wrap(italic, 'em');
  wrap(strong, 'strong');
  wrap(underline, 'u');
  wrap(del, 'del');
  wrap(code, 'code');
  wrap(mark, 'mark');
  return currentContent;
}

export function Base(props) {
  var component = props.component,
      children = props.children,
      className = props.className,
      mark = props.mark,
      code = props.code,
      underline = props.underline,
      del = props.del,
      italic = props.italic,
      strong = props.strong,
      _props$html = props.html,
      html = _props$html === void 0 ? false : _props$html,
      _props$ellipsis = props.ellipsis,
      ellipsis = _props$ellipsis === void 0 ? false : _props$ellipsis,
      style = props.style,
      restProps = _objectWithoutProperties(props, ["component", "children", "className", "mark", "code", "underline", "del", "italic", "strong", "html", "ellipsis", "style"]);

  var prefix = classnames(usePrefixCls('typography', {
    ellipsis: !!ellipsis
  }), className);
  var maxRows = typeof ellipsis === 'boolean' ? 1 : ellipsis.rows;
  var mergedStyle = Object.assign({}, style, ellipsis ? {
    WebkitLineClamp: maxRows
  } : {});

  if (html && typeof children === 'string') {
    return React.createElement(component, _objectSpread({
      className: prefix,
      dangerouslySetInnerHTML: {
        __html: children
      }
    }, restProps));
  }

  return React.createElement(component, _objectSpread({
    className: prefix,
    style: mergedStyle
  }, restProps), wrapperDecorations({
    mark: mark,
    code: code,
    underline: underline,
    del: del,
    italic: italic,
    strong: strong
  }, children));
}